import {
  bucketsFromAggregationWithMatches,
  toArray,
  validGroups,
} from './service-facet-helpers/normalizing-facet';
import {
  buildServiceGroupsFromCodes,
  groupsFromBucketsWithoutCptMetadata,
} from './service-facet-helpers/grouping-attributes';

export function buildServiceFacetGroups(store, buckets, { includeZeroDocCounts = true } = {}) {
  let { list, docCountByKey } = bucketsFromAggregationWithMatches(buckets, {
    includeZeroDocCounts,
  });

  let codes = toArray(store.peekAll('cpt-code'));
  if (!codes.length) {
    if (!list.length) {
      return [];
    }
    return groupsFromBucketsWithoutCptMetadata(list);
  }

  let groups = buildServiceGroupsFromCodes(codes, docCountByKey);
  return validGroups(groups) ? groups : groupsFromBucketsWithoutCptMetadata(list);
}
